document.addEventListener("click", async function (event) {
  const trigger = event.target.closest(
    'a[href*="/products/bolsas?quickview=1"]'
  );

  // No interviene en ningún otro enlace.
  if (!trigger) return;

  event.preventDefault();

  const quickViewWrapper = document.getElementById("quickViewWrapper");
  const productUrl = "/products/bolsas";

  // Si el quick view no existe, abre la página completa.
  if (!quickViewWrapper) {
    window.location.href = productUrl;
    return;
  }

  try {
    const response = await fetch(
      `${productUrl}?view=quickview`
    );

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    quickViewWrapper.innerHTML = await response.text();

    if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }

    document.body.classList.add("overflow-hidden");
    quickViewWrapper.classList.add("show__modal");
  } catch (error) {
    console.error("No fue posible abrir el quick view:", error);

    // Respaldo: abre la página normal.
    window.location.href = productUrl;
  }
});